import styles from "./index.module.css";

export const EmptyState = () => {
  return <div className={styles.container}>Setting up your call...</div>;
};
